import {
  IconActivity,
  IconCurrencyDollar,
  IconGardenCart,
  IconGitBranch,
  IconLogout,
  IconMoneybag,
  IconTrash,
} from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getAuthorizationHeader, http } from '../config/http';
import Layouts from '../layouts/Layouts';
import BarangCabang from '../components/Kasir/BarangCabang';
import { DinamicTitle } from '../utils/DinamicTitle';
import LayoutsKasir from '../layouts/LayoutsKasir';
import SpinnerGetData from '../components/common/SpinnerGetData';

const Dashboard = () => {
  DinamicTitle('Dashboard || Komaladewi');
  const check = localStorage.getItem('role');
  const navigate = useNavigate();
  const [penjualanHariIni, setPenjualanHariIni] = useState(0);
  const [saldoPenjualanHariIni, setsaldoPenjualanHariIni] = useState(0);
  const [pembelianHariIni, setPembelianHariIni] = useState('');
  const [total_saldo, setTotalSaldo] = useState('');

  const [saldoPembelian, setSaldoPembelian] = useState('');

  const [barangCabang, setBarangCabang] = useState([]);
  const [loadingDataCabang, setLoadingDataCabang] = useState(false);
  const [totalBarangCabang, setTotalBarangCabang] = useState(0);

  const role = localStorage.getItem('role');
  const [totalBeratSemuaBarang, setTotalBeratSemuaBarang] = useState(0);
  const [totalBeratPenjualan, setTotalBeratPenjualan] = useState(0);
  const [totalBeratPembelian, setTotalBeratPembelian] = useState(0);
  const [loadingGetDataHome, setLoadingGetDataHome] = useState(false);

  const [jumlahBarangKeluarHariIni, setJumlahBarangKeluarHariIni] = useState(0);
  const [jumlahBarangMasukHariIni, setJumlahBarangMasukKariIni] = useState(0);
  const [jumlahBeratBarangMasukHariIni, setJumalahBeratBarangMasukHariIni] = useState(0);
  const [jumlahBeratBarangKeluarHariIni, setJumlahBeratBarangKeluarHariIni] = useState(0);

  const [jumlahBarangTerhapusHariIni, setJumlahBarangTerhapusHariIni] = useState(0);
  const [jumlahBeratBarangTerhapusHariIni, setJumlahBeratBarangTerhapusHariIni] = useState(0);

  useEffect(() => {
    async function getTransaksiHariIni() {
      setLoadingGetDataHome(true);
      await http
        .get(`home`, {
          headers: { Authorization: getAuthorizationHeader() },
        })
        .then((res) => {
          setTotalBarangCabang(res.data.total_barang);
          setJumlahBarangKeluarHariIni(res.data.jumlah_barang_keluar_hari_ini);
          setJumlahBarangMasukKariIni(res.data.jumlah_barang_masuk_hari_ini);
          setJumlahBeratBarangKeluarHariIni(res.data.total_berat_barang_keluar_hari_ini);
          setJumalahBeratBarangMasukHariIni(res.data.total_berat_barang_masuk_hari_ini);
          setJumlahBarangTerhapusHariIni(res.data.jumlah_barang_terhapus_hari_ini ?? 0);
          setJumlahBeratBarangTerhapusHariIni(res.data.total_berat_barang_terhapus_hari_ini ?? 0);
          setSaldoPembelian(res.data.total_saldo_pembelian_hari_ini);
          setsaldoPenjualanHariIni(res.data.total_saldo_penjualan_hari_ini);
          setTotalSaldo(res.data.total_saldo);
          setPenjualanHariIni(res.data.total_penjualan_hari_ini);
          setPembelianHariIni(res.data.total_pembelian_hari_ini);
          setTotalBeratSemuaBarang(res.data.total_berat_barang);
          setTotalBeratPenjualan(res.data.total_berat_penjualan_hari_ini);
          setTotalBeratPembelian(res.data.total_berat_pembelian_hari_ini);
        })
        .catch((err) => {
          if (err.code === 'ERR_NETWORK') {
            toast.warning('Periksa jaringan internet', { autoClose: 600, });
          } else if (err.response.status === 401) {
            navigate('/login');
          }
        });
      setLoadingGetDataHome(false);
    }
    getTransaksiHariIni();
  }, [navigate]);

  const [saldoCabang, setSaldoCabang] = useState(0);

  function numberWithCommas(x) {
    if (x === null || x === undefined || x === '') return '0';
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  const check_login = localStorage.getItem('role');
  function roundNumber(number) {
    if (number === null || number === undefined || number === '') return '0.000';
    const cleaned = typeof number === 'string' ? number.replace(/,/g, '') : number;
    const num = Number(cleaned);
    return isNaN(num) ? '0.000' : num.toFixed(3);
  }

  if (check_login === 'kasir' || check_login === 'kasir_pembelian') {
    return (
      <LayoutsKasir>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5 py-2">
          {/* Card 1: Jumlah Barang */}
          <div className="bg-white dark:bg-[#111a2e] border border-slate-200 dark:border-slate-800/80 p-5 sm:p-6 rounded-2xl shadow-sm dark:shadow-black/20 flex items-center justify-between transition-all">
            <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-amber-500 flex items-center justify-center flex-shrink-0 shadow-sm text-white">
              <IconGitBranch size={26} stroke={2} />
            </div>
            <div className="text-right flex-1 pl-4">
              <h5 className="font-bold uppercase text-slate-400 dark:text-slate-400 text-xs tracking-wider mb-1">
                Jumlah Barang
              </h5>
              <h3 className="font-extrabold text-lg sm:text-xl lg:text-2xl text-slate-800 dark:text-white font-sans tracking-tight">
                {loadingGetDataHome ? (
                  <SpinnerGetData />
                ) : (
                  <span>
                    {totalBarangCabang || 0} PCS | {roundNumber(totalBeratSemuaBarang)} GR
                  </span>
                )}
              </h3>
            </div>
          </div>

          {/* Card 2: Jumlah Penjualan Hari Ini (Kasir Penjualan) */}
          {check_login === 'kasir' && (
            <div className="bg-white dark:bg-[#111a2e] border border-slate-200 dark:border-slate-800/80 p-5 sm:p-6 rounded-2xl shadow-sm dark:shadow-black/20 flex items-center justify-between transition-all">
              <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-emerald-500 flex items-center justify-center flex-shrink-0 shadow-sm text-white">
                <IconGardenCart size={26} stroke={2} />
              </div>
              <div className="text-right flex-1 pl-4">
                <h5 className="font-bold uppercase text-slate-400 dark:text-slate-400 text-xs tracking-wider mb-1">
                  Jumlah Penjualan Hari Ini
                </h5>
                <h3 className="font-extrabold text-lg sm:text-xl lg:text-2xl text-slate-800 dark:text-white font-sans tracking-tight">
                  {loadingGetDataHome ? (
                    <SpinnerGetData />
                  ) : (
                    <span>
                      {penjualanHariIni || 0} PCS | {roundNumber(totalBeratPenjualan)} GR
                    </span>
                  )}
                </h3>
              </div>
            </div>
          )}

          {/* Card 3: Jumlah Pembelian Hari Ini (Kasir Pembelian) */}
          {check_login === 'kasir_pembelian' && (
            <div className="bg-white dark:bg-[#111a2e] border border-slate-200 dark:border-slate-800/80 p-5 sm:p-6 rounded-2xl shadow-sm dark:shadow-black/20 flex items-center justify-between transition-all">
              <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-rose-500 flex items-center justify-center flex-shrink-0 shadow-sm text-white">
                <IconGardenCart size={26} stroke={2} />
              </div>
              <div className="text-right flex-1 pl-4">
                <h5 className="font-bold uppercase text-slate-400 dark:text-slate-400 text-xs tracking-wider mb-1">
                  Jumlah Pembelian Hari Ini
                </h5>
                <h3 className="font-extrabold text-lg sm:text-xl lg:text-2xl text-slate-800 dark:text-white font-sans tracking-tight">
                  {loadingGetDataHome ? (
                    <SpinnerGetData />
                  ) : (
                    <span>
                      {pembelianHariIni || 0} PCS | {roundNumber(totalBeratPembelian)} GR
                    </span>
                  )}
                </h3>
              </div>
            </div>
          )}

          {/* Card 4: Total Saldo */}
          <div className="bg-white dark:bg-[#111a2e] border border-slate-200 dark:border-slate-800/80 p-5 sm:p-6 rounded-2xl shadow-sm dark:shadow-black/20 flex items-center justify-between transition-all">
            <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-amber-600 flex items-center justify-center flex-shrink-0 shadow-sm text-white">
              <IconMoneybag size={26} stroke={2} />
            </div>
            <div className="text-right flex-1 pl-4">
              <h5 className="font-bold uppercase text-slate-400 dark:text-slate-400 text-xs tracking-wider mb-1">
                Total Saldo
              </h5>
              <h3 className="font-extrabold text-lg sm:text-xl lg:text-2xl text-slate-800 dark:text-white font-sans tracking-tight">
                {loadingGetDataHome ? <SpinnerGetData /> : <span>Rp {numberWithCommas(total_saldo || saldoCabang || 0)}</span>}
              </h3>
            </div>
          </div>

          {/* Card 5: Total Pembelian Hari Ini (Kasir Pembelian) */}
          {check_login === 'kasir_pembelian' && (
            <div className="bg-white dark:bg-[#111a2e] border border-slate-200 dark:border-slate-800/80 p-5 sm:p-6 rounded-2xl shadow-sm dark:shadow-black/20 flex items-center justify-between transition-all">
              <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-slate-700 flex items-center justify-center flex-shrink-0 shadow-sm text-white">
                <IconCurrencyDollar size={26} stroke={2} />
              </div>
              <div className="text-right flex-1 pl-4">
                <h5 className="font-bold uppercase text-slate-400 dark:text-slate-400 text-xs tracking-wider mb-1">
                  Total Pembelian Hari Ini
                </h5>
                <h3 className="font-extrabold text-lg sm:text-xl lg:text-2xl text-slate-800 dark:text-white font-sans tracking-tight">
                  {loadingGetDataHome ? <SpinnerGetData /> : <span>Rp {numberWithCommas(saldoPembelian || 0)}</span>}
                </h3>
              </div>
            </div>
          )}

          {/* Card 6: Total Penjualan Hari Ini (Kasir Penjualan) */}
          {check_login === 'kasir' && (
            <div className="bg-white dark:bg-[#111a2e] border border-slate-200 dark:border-slate-800/80 p-5 sm:p-6 rounded-2xl shadow-sm dark:shadow-black/20 flex items-center justify-between transition-all">
              <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-emerald-600 flex items-center justify-center flex-shrink-0 shadow-sm text-white">
                <IconCurrencyDollar size={26} stroke={2} />
              </div>
              <div className="text-right flex-1 pl-4">
                <h5 className="font-bold uppercase text-slate-400 dark:text-slate-400 text-xs tracking-wider mb-1">
                  Total Penjualan Hari Ini
                </h5>
                <h3 className="font-extrabold text-lg sm:text-xl lg:text-2xl text-slate-800 dark:text-white font-sans tracking-tight">
                  {loadingGetDataHome ? (
                    <SpinnerGetData />
                  ) : (
                    <span>Rp {numberWithCommas(saldoPenjualanHariIni || 0)}</span>
                  )}
                </h3>
              </div>
            </div>
          )}
        </div>
      </LayoutsKasir>
    );
  } else {
    return (
      <Layouts
      // title={`Dashboard ${ check === 'admin' ? 'Admin' : toko ? toko : ''}`}
      >
        <div className={`flex flex-wrap p-3 dark:bg-slate-950`}>
          <div className="w-full md:w-1/2 xl:w-1/3 md:p-2 p-2">
            <div className="bg-white dark:bg-slate-900 border dark:border-slate-800 shadow p-[17px] rounded-lg">
              <div className="flex flex-row items-center">
                <div className="flex-shrink pr-4">
                  <div className=" p-3 bg-amber-500 rounded-lg">
                    <IconGitBranch className="text-white" />
                  </div>
                </div>
                <div className="flex-1 text-right md:text-end">
                  <h5 className="font-bold uppercase text-gray-500 dark:text-slate-400 text-xs">Jumlah Barang</h5>
                  <h3 className="font-bold text-base text-slate-800 dark:text-slate-100">
                    {loadingGetDataHome ? (
                      <SpinnerGetData />
                    ) : (
                      <span>
                        {totalBarangCabang || 0} PCS | {roundNumber(totalBeratSemuaBarang)} GR
                      </span>
                    )}
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full md:w-1/2 xl:w-1/3 md:p-2 p-2">
            <div className="bg-white dark:bg-slate-900 border dark:border-slate-800 shadow p-[17px] rounded-lg">
              <div className="flex flex-row items-center">
                <div className="flex-shrink pr-4">
                  <div className=" p-3 bg-emerald-500 rounded-lg">
                    <IconGardenCart className="text-white" />
                  </div>
                </div>
                <div className="flex-1 text-right md:text-end">
                  <h5 className="font-bold uppercase whitespace-nowrap text-gray-500 dark:text-slate-400 text-xs">Jumlah Penjualan Hari Ini</h5>
                  <h3 className="font-bold text-base text-slate-800 dark:text-slate-100">
                    {loadingGetDataHome ? (
                      <SpinnerGetData />
                    ) : (
                      <span>
                        {penjualanHariIni || 0} PCS | {roundNumber(totalBeratPenjualan)} GR
                      </span>
                    )}{' '}
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full md:w-1/2 xl:w-1/3 md:p-2 p-2">
            <div className="bg-white dark:bg-slate-900 border dark:border-slate-800 shadow p-[17px] rounded-lg">
              <div className="flex flex-row items-center">
                <div className="flex-shrink pr-4">
                  <div className=" p-3 bg-rose-500 rounded-lg">
                    <IconGardenCart className="text-white" />
                  </div>
                </div>
                <div className="flex-1 text-right md:text-end">
                  <h5 className="font-bold uppercase whitespace-nowrap text-gray-500 dark:text-slate-400 text-xs">Jumlah Pembelian Hari Ini</h5>
                  <h3 className="font-bold text-base text-slate-800 dark:text-slate-100">
                    {loadingGetDataHome ? (
                      <SpinnerGetData />
                    ) : (
                      <span>
                        {pembelianHariIni || 0} PCS | {roundNumber(totalBeratPembelian)} GR{' '}
                      </span>
                    )}
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full md:w-1/2 xl:w-1/3 md:p-2 p-2">
            <div className="bg-white dark:bg-slate-900 border dark:border-slate-800 shadow p-[17px] rounded-lg">
              <div className="flex flex-row items-center">
                <div className="flex-shrink pr-4">
                  <div className=" p-3 bg-amber-600 rounded-lg">
                    <IconCurrencyDollar className="text-white" />
                  </div>
                </div>
                <div className="flex-1 text-right ">
                  <h5 className="font-bold uppercase text-gray-500 dark:text-slate-400 text-xs">Total Saldo</h5>
                  <h3 className="font-bold text-base text-slate-800 dark:text-slate-100">
                    {loadingGetDataHome ? <SpinnerGetData /> : <span>Rp {numberWithCommas(total_saldo || saldoCabang || 0)}</span>}
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full md:w-1/2 xl:w-1/3 md:p-2 p-2">
            <div className="bg-white dark:bg-slate-900 border dark:border-slate-800 shadow p-[17px] rounded-lg">
              <div className="flex flex-row items-center">
                <div className="flex-shrink pr-4">
                  <div className=" p-3 bg-emerald-600 rounded-lg">
                    <IconCurrencyDollar className="text-white" />
                  </div>
                </div>
                <div className="flex-1 text-right ">
                  <h5 className="font-bold uppercase text-gray-500 dark:text-slate-400 text-xs">Total Penjualan Hari ini</h5>
                  <h3 className="font-bold text-base text-slate-800 dark:text-slate-100">
                    {loadingGetDataHome ? (
                      <SpinnerGetData />
                    ) : (
                      <span>Rp {numberWithCommas(saldoPenjualanHariIni || 0)}</span>
                    )}
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full md:w-1/2 xl:w-1/3 md:p-2 p-2">
            <div className="bg-white dark:bg-slate-900 border dark:border-slate-800 shadow p-[17px] rounded-lg">
              <div className="flex flex-row items-center">
                <div className="flex-shrink pr-4">
                  <div className=" p-3 bg-slate-700 rounded-lg">
                    <IconCurrencyDollar className="text-white" />
                  </div>
                </div>
                <div className="flex-1 text-right ">
                  <h5 className="font-bold uppercase text-gray-500 dark:text-slate-400 text-xs">Total Pembelian hari ini</h5>
                  <h3 className="font-bold text-base text-slate-800 dark:text-slate-100">
                    {loadingGetDataHome ? <SpinnerGetData /> : <span>Rp {numberWithCommas(saldoPembelian || 0)}</span>}
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <div className={`${role === 'kasir' ? '' : 'hidden'} w-full md:w-1/2 xl:w-1/3 md:p-2 p-2`}>
            <div className="bg-white dark:bg-slate-900 border dark:border-slate-800 shadow p-5 rounded-lg">
              <div className="flex flex-row items-center">
                <div className="flex-shrink pr-4">
                  <div className=" p-3 bg-amber-600 rounded-lg">
                    <IconMoneybag className="text-white" />
                  </div>
                </div>
                <div className="flex-1 text-right ">
                  <h5 className="font-bold uppercase text-gray-500 dark:text-slate-400 text-xs">Saldo</h5>
                  <h3 className="font-bold text-base text-slate-800 dark:text-slate-100">Rp {numberWithCommas(total_saldo || saldoCabang || 0)}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="grid sm:grid-cols-3 w-full p-2 dark:bg-slate-950">
          <div className="w-full  md:p-2 p-2">
            <div className="bg-white dark:bg-slate-900 border dark:border-slate-800 shadow p-[17px] rounded-lg">
              <div className="flex flex-row items-center">
                <div className="flex-shrink pr-4">
                  <div className=" p-3 bg-amber-500 rounded-lg">
                    <IconActivity className="text-white" />
                  </div>
                </div>
                <div className="flex-1 text-right ">
                  <h5 className="font-bold uppercase text-gray-500 dark:text-slate-400 text-xs">BARANG KE ETALASE HARI INI</h5>
                  <h3 className="font-bold text-base text-slate-800 dark:text-slate-100">
                    {loadingGetDataHome ? (
                      <SpinnerGetData />
                    ) : (
                      <span>
                        {' '}
                        {jumlahBarangKeluarHariIni || 0} PCS | {roundNumber(jumlahBeratBarangKeluarHariIni)} GR{' '}
                      </span>
                    )}
                  </h3>
                </div>
              </div>
            </div>
          </div>
          {(role === 'admin' || role === 'owner' || role === 'operator_rumah' || role === 'supervisor') && (
            <div className="w-full  md:p-2 p-2">
              <div className="bg-white dark:bg-slate-900 border dark:border-slate-800 shadow p-[17px] rounded-lg">
                <div className="flex flex-row items-center">
                  <div className="flex-shrink pr-4">
                    <div className=" p-3 bg-emerald-500 rounded-lg">
                      <IconLogout className="text-white" />
                    </div>
                  </div>
                  <div className="flex-1 text-right ">
                    <h5 className="font-bold uppercase text-gray-500 dark:text-slate-400 text-xs">BARANG KE BRANKAS HARI INI</h5>
                    <h3 className="font-bold text-base text-slate-800 dark:text-slate-100">
                      {loadingGetDataHome ? (
                        <SpinnerGetData />
                      ) : (
                        <span>
                          {' '}
                          {jumlahBarangMasukHariIni || 0} PCS | {roundNumber(jumlahBeratBarangMasukHariIni)} GR{' '}
                        </span>
                      )}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="w-full  md:p-2 p-2">
            <div className="bg-white dark:bg-slate-900 border dark:border-slate-800 shadow p-[17px] rounded-lg">
              <div className="flex flex-row items-center">
                <div className="flex-shrink pr-4">
                  <div className=" p-3 bg-red-500 rounded-lg">
                    <IconTrash className="text-white" />
                  </div>
                </div>
                <div className="flex-1 text-right ">
                  <h5 className="font-bold uppercase text-gray-500 dark:text-slate-400 text-xs">BARANG DIHAPUS HARI INI</h5>
                  <h3 className="font-bold text-base text-slate-800 dark:text-slate-100">
                    {loadingGetDataHome ? (
                      <SpinnerGetData />
                    ) : (
                      <span>
                        {' '}
                        {jumlahBarangTerhapusHariIni || 0} PCS | {roundNumber(jumlahBeratBarangTerhapusHariIni)} GR{' '}
                      </span>
                    )}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="p-3 dark:bg-slate-950">
            {check === 'kasir' ? (
              <BarangCabang barangCabang={barangCabang} loadingDataCabang={loadingDataCabang} />
            ) : (
              <></>// <GrafikChart />
            )}
          </div>
        </div>
      </Layouts>
    );
  }
};

export default Dashboard;